import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type TypeAuthStore = {
  id: string | null
  userName: string | null
  role: string | null
  token: string | null
  refreshToken: string | null
  setToken: (token: string, refreshToken: string) => void
  setSession: (
    token: string,
    refreshToken: string,
    userName: string,
    role: string,
    id: string
  ) => void
  clearSession: () => void
}

export const useAuthStore = create<TypeAuthStore>()(
  persist(
    (set) => ({
      id: null,
      token: null,
      refreshToken: null,
      userName: null,
      role: null,
      setToken: (token, refreshToken) => set({ token, refreshToken }),
      setSession: (token, refreshToken, userName, role, id) =>
        set({ userName, role, token, id, refreshToken }),
      clearSession: () =>
        set({
          token: null,
          refreshToken: null,
          userName: null,
          role: null,
          id: null
        })
    }),
    {
      name: 'auth-token'
    }
  )
)
